import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { controlList, controlStatus, delControl } from './request';
import controlModel from './controlModel';
export default {
  components: {
    controlModel
  },
  data() {
    return {
      form: {
        name: ''
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        title: '序号',
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '控件名称'
        },
        title: '控件名称',
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '标识'
        },
        title: '标识',
        dataIndex: 'mark',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '应用页面类型'
        },
        title: '应用页面类型',
        dataIndex: 'type',
        key: 'type',
        align: 'center',
        scopedSlots: {
          customRender: 'type'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        title: '创建时间',
        dataIndex: 'createAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        title: '状态',
        dataIndex: 'status',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      }, {
        slots: {
          title: '操作'
        },
        title: '操作',
        width: 300,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      controlShow: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    replaceFn(text) {
      let _val = text.split(',');
      if (_val.length && _val.length > 1) {
        let value;
        _val.map((item, index) => {
          if (index == 0) {
            value = this.$t(item);
          } else {
            value += ',' + this.$t(item);
          }
        });
        return value;
      } else {
        return this.$t(text);
      }
    },
    async getDataFun() {
      const {
        items,
        totalNum
      } = await controlList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleEdit(val) {
      this.controlShow = true;
      this.$nextTick(() => {
        this.$refs.controlRef.init(val);
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    checkedFun(val) {
      if (!this.isAuth('home.controlsStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      controlStatus({
        controlsId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        this.getDataFun();
      });
    },
    handleDelete(val) {
      if (val.status == 1) {
        return this.$message.error(this.$t('需要先禁用该控件再删除'));
      }
      let _this = this;
      this.$alert(_this.$t('是否确认删除该控件单元？'), {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delControl({
          controlsId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    }
  }
};